import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ethers } from "ethers";

import { Container } from "../../../Components/StyledComponents/StyledComponents";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";

// import BannerCategories from "./BannerCategories";
import NftCategorisTabs from "./NftCategorisTabs";
import { nftContractABI } from "../../../config/data";
import BannerNftMarket from "../NftMarketPage/BannerNftMarket";

const Root = styled.div`
  margin-bottom: 40px;
`;

const NftCategories = ({ allContractDetails }) => {
  const params = useParams();
  const [allFeaturedData, setAllFeaturedData] = useState({});

  // console.log("id", params);

  useEffect(() => {
    if (params?.id) {
      fetchFeaturedData(params.id);
    }
  }, []);

  useEffect(() => {
    if (params?.id) {
      fetchFeaturedData(params.id);
    }
  }, [allContractDetails]);

  const getNFTContract = async (nftAddress) => {
    return new ethers.Contract(
      nftAddress,
      nftContractABI,
      allContractDetails?.signer
    );
  };

  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    return response.data;
  };

  const fetchFeaturedData = async (contract) => {
    const obj = {};

    // const nftContract = await getNFTContract(contract);

    // await getName(nftContract)
    //   .then(async (nftContractName) => {
    //     // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(allContractDetails?.nftStakingContract)
    //     const metaspaceBaseApiURL =
    //       "https://nftbe.metaspacechain.com/nftmarketplace/api/v1/get_token_details/";
    //     await totalSupply(nftContract)
    //       .then(async (supplyCount) => {
    //         let i = 0;
    //         while (i < Number(supplyCount)) {
    //           if (i === 100) {
    //             setAllFeaturedData({ ...obj });
    //             return;
    //           }
    //           await nftInfo(
    //             allContractDetails?.metaspaceNFTMarketplaceContract,
    //             contract.toLowerCase(),
    //             i
    //           )
    //             .then(async (nftContractInfo) => {
    //               if (Number(nftContractInfo.price) > 0) {
    //                 const nftDetail = await fetchNftDetail(
    //                   contract.toLowerCase(),
    //                   i,
    //                   metaspaceBaseApiURL
    //                 );
    //                 const dataList = obj[nftContractName]?.data || [];
    //                 const detailsList =
    //                   obj[nftContractName]?.fetchDetails || [];

    //                 obj[nftContractName] = {
    //                   ...obj[nftContractName],
    //                   supply: Number(supplyCount),
    //                   contract,
    //                   i,
    //                   fetchDetails: [...detailsList, nftDetail],
    //                   data: [...dataList, nftContractInfo],
    //                 };

    //                 if (obj[nftContractName].data.length === 12) {
    //                   i = null;
    //                   setAllFeaturedData({ ...obj });
    //                   return;
    //                 }
    //               } else {
    //                 obj[nftContractName] = {
    //                   ...obj[nftContractName],
    //                   supply: Number(supplyCount),
    //                 };
    //               }
    //               i++;
    //             })
    //             .catch((err) => {
    //               i = null;
    //               setAllFeaturedData({ ...obj });
    //               return;
    //             });
    //         }

    //         setAllFeaturedData({ ...obj });
    //       })
    //       .catch((err) => {
    //         console.log("err inside a totalsupply", err);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log("err inside a getName", err);
    //   });

    return obj;
  };

  // console.log("allFeaturedData", allFeaturedData);

  return (
    <Root>
      <Container>
        <NftMarketHomepage allContractDetails={allContractDetails} />
        {/* <BannerCategories /> */}
        <BannerNftMarket />
        <NftCategorisTabs
          list={allFeaturedData}
          allContractDetails={allContractDetails}
        />
      </Container>
    </Root>
  );
};

export default NftCategories;
